<template>
  <f7-page name="oeb-analisis-dif" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>An&aacute;lisis diferencias OEB vs TPC(SI)</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="zoomOut" style="font-size:12px;min-width:20px">&minus;</f7-link>
        <span style="font-size:11px;min-width:30px;text-align:center">{{ zoom }}%</span>
        <f7-link @click="zoomIn" style="font-size:12px;min-width:20px">+</f7-link>
        <f7-link icon-f7="arrow_2_circlepath" @click="cargarDatos" title="Recargar"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · La pantalla se sirve de oeb_analisis_cache; "Recalcular" la borra y la reescribe. -->
    <div class="sello-datos-bar">
      <sello-datos estado="fecha" :fecha="datos && datos.fechaCalculo" />
    </div>

    <!-- BANNER FUNCIONALIDAD EN DESARROLLO -->
    <div style="background:#FEF3C7;border-left:4px solid #F59E0B;padding:12px 20px;display:flex;align-items:center;gap:12px;font-size:13px;color:#78350F">
      <span style="font-size:20px">🚧</span>
      <div>
        <strong style="color:#B45309">Funcionalidad en desarrollo</strong>
        <div style="font-size:11px;margin-top:2px;color:#92400E">
          Los datos y el comportamiento pueden cambiar. Úsese con criterio.
        </div>
      </div>
    </div>

    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
      <div class="contenido-anal" :style="{ fontSize: (zoom * 0.12) + 'px' }">

        <!-- SELECTOR MES -->
        <div class="mes-selector">
          <f7-link @click="mesPrevio" icon-f7="chevron_left"></f7-link>
          <select v-model="anio" @change="cargarDatos" class="select-anio">
            <option v-for="a in aniosDisponibles" :key="a" :value="a">{{ a }}</option>
          </select>
          <select v-model="mes" @change="cargarDatos" class="select-mes">
            <option v-for="(nombre, idx) in nombresMeses" :key="idx" :value="idx + 1">{{ nombre }}</option>
          </select>
          <f7-link @click="mesSiguiente" icon-f7="chevron_right"></f7-link>
        </div>

        <!-- KPIs -->
        <div class="kpis-grid" v-if="datos">
          <div class="kpi-card"><div class="kpi-label">OEB calendario</div><div class="kpi-val" style="color:#1a2744">{{ fmtEur(datos.totalOEB) }}</div></div>
          <div class="kpi-card"><div class="kpi-label">TPC(SI) reparto</div><div class="kpi-val" style="color:#dc3545">{{ fmtEur(datos.totalTPC) }}</div></div>
          <div class="kpi-card"><div class="kpi-label">Diferencia</div><div class="kpi-val" :class="datos.diferencia >= 0 ? 'vpos' : 'vneg'">{{ fmtEurSigno(datos.diferencia) }}</div></div>
          <div class="kpi-card"><div class="kpi-label">N&ordm; incidencias</div><div class="kpi-val" style="color:#555">{{ datos.totalItems }}</div></div>
        </div>

        <!-- FILTROS -->
        <div class="filtros-bar" v-if="datos">
          <select v-model="filtroCausa" class="filtro-select">
            <option value="">Todas las causas</option>
            <option v-for="c in causasDisponibles" :key="c" :value="c">{{ causaLabel(c) }}</option>
          </select>
          <select v-model="filtroPersona" class="filtro-select">
            <option value="">Todas las personas</option>
            <option v-for="p in personasDisponibles" :key="p" :value="p">{{ p }}</option>
          </select>
          <button v-if="filtroCausa || filtroPersona" class="btn-limpiar" @click="filtroCausa = ''; filtroPersona = ''">Limpiar filtros</button>
          <button class="btn-recalcular" @click="recalcular" :disabled="recalculando" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
            {{ recalculando ? 'Recalculando...' : 'Recalcular' }}
          </button>
        </div>

        <!-- BADGES CAUSAS -->
        <div class="causas-bar" v-if="datos && datos.porCausa">
          <div v-for="(imp, causa) in datos.porCausa" :key="causa" class="causa-card"
               :style="{ borderLeftColor: causaColor(causa), background: filtroCausa === causa ? causaColor(causa) : '#fff', color: filtroCausa === causa ? '#fff' : '#333' }"
               @click="filtroCausa = filtroCausa === causa ? '' : causa">
            <div class="causa-card-nombre">{{ causaLabel(causa) }}</div>
            <div class="causa-card-val">{{ fmtEurCorto(imp) }} &euro;</div>
          </div>
        </div>

        <!-- TABLA PERSONAS -->
        <div class="tabla-wrap" v-if="personasFiltradas.length">
          <table class="tabla-anal">
            <thead>
              <tr>
                <th style="text-align:left">C&Oacute;D.</th>
                <th>OEB</th>
                <th>TPC(SI)</th>
                <th>DIFERENCIA</th>
                <th style="text-align:left">CAUSA PRINCIPAL</th>
                <th>ITEMS</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="p in personasFiltradas">
                <tr :key="p.codigoPersonal" class="fila-persona" @click="toggleExpand(p.codigoPersonal)">
                  <td style="text-align:left"><strong>{{ p.codigoPersonal }}</strong></td>
                  <td>{{ fmtEurCorto(p.oebTotal) }}</td>
                  <td>{{ fmtEurCorto(p.tpcTotal) }}</td>
                  <td :class="p.diferencia >= 0 ? 'vpos' : 'vneg'">{{ fmtEurSigno(p.diferencia) }}</td>
                  <td style="text-align:left"><span class="causa-badge-sm" :style="{ background: causaColor(causaPrincipal(p)) }">{{ causaLabel(causaPrincipal(p)) }}</span></td>
                  <td>{{ contarItems(p) }}</td>
                  <td><span style="font-size:10px;color:#888">{{ expandido === p.codigoPersonal ? '&#9650;' : '&#9660;' }}</span></td>
                </tr>
                <tr v-if="expandido === p.codigoPersonal" :key="p.codigoPersonal + '-det'" class="fila-detalle">
                  <td colspan="7" style="padding:0">
                    <div class="detalle-inner">
                      <!-- Semanas resumen -->
                      <div class="sem-resumen">
                        <div v-for="s in semanasPersona(p)" :key="s.semana" class="sem-card">
                          <div class="sem-card-titulo">S{{ s.semana }}</div>
                          <div style="font-size:10px">OEB: {{ fmtEurCorto(s.oebSemana) }}</div>
                          <div style="font-size:10px">TPC: {{ fmtEurCorto(s.tpcSemana) }}</div>
                          <div style="font-size:10px" :class="s.diferencia >= 0 ? 'vpos' : 'vneg'">Dif: {{ fmtEurSigno(s.diferencia) }}</div>
                        </div>
                      </div>
                      <!-- Toggle mostrar OK -->
                      <div style="padding:4px 0;text-align:right">
                        <label style="font-size:11px;color:#666;cursor:pointer"><input type="checkbox" v-model="mostrarOk" style="margin-right:4px" />Mostrar todas las l&iacute;neas</label>
                      </div>
                      <!-- Items tabla -->
                      <table class="tabla-items">
                        <thead><tr>
                          <th>Sem.</th><th style="text-align:left">Causa</th><th>Pedido</th><th>L&iacute;nea</th>
                          <th style="text-align:left">Servicio</th><th style="text-align:left">Cliente</th>
                          <th>OEB</th><th>TPC</th><th>% Rep.</th><th>Dif.</th><th>F.Plan</th><th>F.Ejec</th><th>Acci&oacute;n</th>
                        </tr></thead>
                        <tbody>
                          <tr v-for="(it, ii) in itemsPersona(p)" :key="ii" :class="ii % 2 === 1 ? 'fila-alt' : ''">
                            <td>S{{ it._sem }}</td>
                            <td style="text-align:left"><span class="causa-badge-sm" :style="{ background: causaColor(it.causa) }">{{ causaLabel(it.causa) }}</span></td>
                            <td>{{ it.numeroPedido || '&mdash;' }}</td>
                            <td>{{ it.numLinea != null ? it.numLinea : '&mdash;' }}</td>
                            <td style="text-align:left;max-width:120px;overflow:hidden;text-overflow:ellipsis">{{ it.servicio || '&mdash;' }}</td>
                            <td style="text-align:left;max-width:100px;overflow:hidden;text-overflow:ellipsis">{{ it.cliente || '&mdash;' }}</td>
                            <td>{{ fmtEurCorto(it.importeOEB) }}</td>
                            <td>{{ fmtEurCorto(it.importeTPC) }}</td>
                            <td :style="it.porcentajeReparto && it.porcentajeReparto < 100 ? {color:'#e6a817',fontWeight:'700'} : {color:'#aaa'}">{{ it.porcentajeReparto ? Math.round(it.porcentajeReparto) + '%' : '100%' }}</td>
                            <td :class="it.diferencia >= 0 ? 'vpos' : 'vneg'">{{ fmtEurSigno(it.diferencia) }}</td>
                            <td>{{ it.fechaPlanificacion ? it.fechaPlanificacion.substring(5) : '&mdash;' }}</td>
                            <td>{{ it.fechaEjecucion ? it.fechaEjecucion.substring(5) : '&mdash;' }}</td>
                            <td>
                              <button v-if="it.pedidoId" class="btn-ver" @click.stop="$f7router.navigate('/pedidos/view/' + it.pedidoId + '/')">Ver &rarr;</button>
                              <button v-else-if="it.idTarea" class="btn-ver" @click.stop="$f7router.navigate('/tarea/view/' + it.idTarea + '/')">Tarea &rarr;</button>
                              <span v-else>&mdash;</span>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr style="font-weight:700;border-top:2px solid #1a2744;background:#f0f4fa">
                            <td colspan="6" style="text-align:right;padding-right:8px">TOTALES</td>
                            <td>{{ fmtEurCorto(itemsPersona(p).reduce(function(s,i){return s+(i.importeOEB||0)},0)) }}</td>
                            <td>{{ fmtEurCorto(itemsPersona(p).reduce(function(s,i){return s+(i.importeTPC||0)},0)) }}</td>
                            <td></td>
                            <td :class="itemsPersona(p).reduce(function(s,i){return s+(i.diferencia||0)},0) >= 0 ? 'vpos' : 'vneg'">{{ fmtEurSigno(itemsPersona(p).reduce(function(s,i){return s+(i.diferencia||0)},0)) }}</td>
                            <td colspan="3"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <f7-block v-if="datos && !personasFiltradas.length" class="text-align-center">
          <p>Sin diferencias para los filtros seleccionados</p>
        </f7-block>

        <f7-block v-if="cargando" class="text-align-center">
          <f7-preloader></f7-preloader>
          <p>Analizando diferencias...</p>
        </f7-block>
      </div>
    </f7-page-content>
  </f7-page>
</template>
<style scoped>
.contenido-anal { font-size:12px; }
.mes-selector { display:flex; align-items:center; justify-content:center; gap:0.8em; padding:0.3em 0.6em 0.2em; }
.select-anio, .select-mes { font-size:1.2em; font-weight:600; padding:0.2em 0.4em; border:1px solid #ddd; border-radius:0.3em; background:white; color:#1a2744; text-align:center; }
.select-anio { min-width:5em; }
.select-mes { min-width:8em; }

.kpis-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:0.4em; padding:0 0.6em 0.3em; }
@media (max-width:600px) { .kpis-grid { grid-template-columns:repeat(2,1fr); } }
.kpi-card { background:linear-gradient(135deg,#fff 0%,#f8fafe 100%); border:1px solid #e8edf3; border-radius:0.5em; padding:0.5em 0.7em; }
.kpi-label { font-size:0.65em; color:#7c8db0; text-transform:uppercase; font-weight:600; }
.kpi-val { font-size:1.3em; font-weight:700; }

.filtros-bar { display:flex; gap:8px; padding:0 0.6em 0.3em; align-items:center; flex-wrap:wrap; }
.filtro-select { font-size:11px; padding:4px 8px; border:1px solid #ddd; border-radius:6px; background:white; }
.btn-limpiar { font-size:10px; padding:4px 10px; border:1px solid #dc3545; border-radius:6px; background:white; color:#dc3545; cursor:pointer; }
.btn-recalcular { font-size:10px; padding:4px 10px; border:1px solid #7B2D8E; border-radius:6px; background:white; color:#7B2D8E; cursor:pointer; font-weight:600; }
.btn-recalcular:hover { background:#7B2D8E; color:white; }
.btn-recalcular:disabled { opacity:0.5; cursor:not-allowed; }

.causas-bar { display:flex; gap:6px; padding:0 0.6em 0.4em; flex-wrap:wrap; }
.causa-card { border-left:4px solid; border:1px solid #e0e0e0; border-radius:8px; padding:6px 10px; cursor:pointer; transition:all 0.15s; min-width:80px; }
.causa-card:hover { box-shadow:0 2px 8px rgba(0,0,0,0.1); }
.causa-card-nombre { font-size:10px; font-weight:600; }
.causa-card-val { font-size:13px; font-weight:700; margin-top:2px; }

.tabla-wrap { padding:0 0.6em; }
.tabla-anal { width:100%; border-collapse:collapse; border:1px solid #dde3ed; border-radius:0.8em; overflow:hidden; }
.tabla-anal thead th { background:#1a2744; color:#c8d3e5; padding:6px 8px; font-size:10px; font-weight:600; text-transform:uppercase; text-align:right; }
.tabla-anal tbody td { padding:5px 8px; border-bottom:1px solid #eef0f5; font-size:11px; text-align:right; }
.fila-persona { cursor:pointer; }
.fila-persona:hover { background:#eef2f9 !important; }
.fila-persona:nth-child(4n+3) { background:#fafbfd; }
.fila-detalle { background:#f5f7fa; }
.detalle-inner { padding:10px 12px; }

.sem-resumen { display:flex; gap:6px; margin-bottom:10px; flex-wrap:wrap; }
.sem-card { background:white; border:1px solid #e0e0e0; border-radius:6px; padding:6px 10px; min-width:70px; text-align:center; }
.sem-card-titulo { font-size:12px; font-weight:700; color:#1a2744; margin-bottom:2px; }

.tabla-items { width:100%; border-collapse:collapse; font-size:11px; }
.tabla-items thead th { padding:4px 5px; background:#eef1f7; border-bottom:1px solid #c8d0de; color:#7c8db0; font-size:9px; font-weight:600; text-align:right; }
.tabla-items tbody td { padding:3px 5px; border-bottom:1px solid #f0f2f5; text-align:right; }
.tabla-items .fila-alt { background:#fafbfd; }

.causa-badge-sm { font-size:9px; padding:2px 6px; border-radius:4px; font-weight:600; color:#fff; display:inline-block; white-space:nowrap; }
.btn-ver { padding:2px 8px; border:1px solid #0d6efd; border-radius:4px; background:white; color:#0d6efd; font-size:10px; cursor:pointer; }
.btn-ver:hover { background:#0d6efd; color:white; }

.vpos { color:#0E6251 !important; font-weight:600; }
.vneg { color:#B71C1C !important; font-weight:600; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; display: flex; flex-wrap: wrap; gap: 8px; }
</style>
<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import Oeb from '../../js/db/Oeb.js';
import SelloDatos from '../../components/SelloDatos.vue';
import carrilPeticiones from '../../js/utils/carrilPeticiones.js';

export default {
  components: { SelloDatos },
  // #769 · El mes va por el carril común de la #472. Sin él, la respuesta de un mes anterior que
  // llegaba tarde se pintaba bajo el selector nuevo, apagaba el «cargando» de la vigente y, además,
  // se guardaba en el navegador como si fuera del mes nuevo: al volver a entrar se restauraba esa.
  created: function() {
    const self = this;
    self.carrilMes = carrilPeticiones({
      deAhora: function() { return [self.anio, self.mes]; },
      vaciar: function() { self.datos = null; self.expandido = null; },
      cargando: function(si) { self.cargando = si; }
    });
  },
  beforeDestroy: function() {
    // El recálculo que se descarta al salir no tiene que volver a leer.
    this.cerrada = true;
    this.carrilMes.invalidar();
  },
  data: function() {
    return {
      anio: new Date().getFullYear(),
      mes: new Date().getMonth() + 1,
      datos: null,
      cargando: false,
      zoom: 100,
      expandido: null,
      filtroCausa: '',
      filtroPersona: '',
      recalculando: false,
      mostrarOk: false
    };
  },
  computed: {
    nombresMeses: function() { return ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']; },
    aniosDisponibles: function() { var a = []; for (var i = 2020; i <= new Date().getFullYear() + 1; i++) a.push(i); return a; },
    causasDisponibles: function() {
      if (!this.datos || !this.datos.porCausa) return [];
      return Object.keys(this.datos.porCausa);
    },
    personasDisponibles: function() {
      if (!this.datos || !this.datos.personas) return [];
      return this.datos.personas.map(function(p) { return p.codigoPersonal; }).sort();
    },
    personasFiltradas: function() {
      if (!this.datos || !this.datos.personas) return [];
      var self = this;
      var lista = self.datos.personas;
      if (self.filtroPersona) {
        lista = lista.filter(function(p) { return p.codigoPersonal === self.filtroPersona; });
      }
      if (self.filtroCausa) {
        lista = lista.filter(function(p) {
          return p.semanas && p.semanas.some(function(s) {
            return s.items && s.items.some(function(it) { return it.causa === self.filtroCausa; });
          });
        });
      }
      return [].concat(lista).sort(function(a, b) { return Math.abs(b.diferencia || 0) - Math.abs(a.diferencia || 0); });
    }
  },
  methods: {
    zoomIn: function() { this.zoom = Math.min(150, this.zoom + 5); },
    zoomOut: function() { this.zoom = Math.max(40, this.zoom - 5); },
    onPageInit: function() {
      var a = localStorage.getItem('oeb_anal_anio'); var m = localStorage.getItem('oeb_anal_mes');
      if (a) this.anio = parseInt(a); if (m) this.mes = parseInt(m);
      // Intentar restaurar desde localStorage
      var cached = localStorage.getItem('oeb_anal_data');
      var cachedAnio = localStorage.getItem('oeb_anal_data_anio');
      var cachedMes = localStorage.getItem('oeb_anal_data_mes');
      if (cached && parseInt(cachedAnio) === this.anio && parseInt(cachedMes) === this.mes) {
        let restaurados;
        try { restaurados = JSON.parse(cached); } catch (e) { restaurados = null; }
        if (restaurados) {
          const self = this;
          // #769 · Lo guardado también entra por el carril, aunque no haya petición: así sabe que
          // hay un mes pintado y lo tira al pedir otro. Pintado por fuera, el primer cambio de mes
          // dejaba lo restaurado debajo del selector nuevo hasta que contestaba el servidor.
          this.carrilMes.lanzar(Promise.resolve(restaurados), {
            exito: function(datos) {
              self.datos = datos;
              const exp = localStorage.getItem('oeb_anal_expandido');
              if (exp) self.expandido = exp;
            }
          });
          return;
        }
      }
      this.cargarDatos();
    },
    cargarDatos: function() {
      localStorage.setItem('oeb_anal_anio', this.anio); localStorage.setItem('oeb_anal_mes', this.mes);
      const self = this;
      const anio = self.anio;
      const mes = self.mes;
      // Recargar el mismo mes no pasa por `vaciar` —el carril no tira lo que se vuelve a pedir—, así
      // que la respuesta sin datos y el fallo tienen que tirarlo aquí. Sin eso, una recarga que no
      // trae nada dejaba a la vista lo de antes como si lo hubiera confirmado; antes del carril se
      // vaciaba al pedir y esa respuesta dejaba la pantalla sin datos (revisión CODEX del PR #1845).
      self.carrilMes.lanzar(Oeb.getAnalisisDiferencias(anio, mes), {
        exito: function(res) {
          if (unwrapDto(res)) {
            self.datos = unwrapDto(res);
            self.guardarEnLocal(anio, mes);
          } else {
            self.datos = null; self.expandido = null;
            // El servidor dice que ese mes no tiene datos: lo guardado de él ya no vale, y al volver
            // a entrar se restauraría como si fuera bueno.
            self.olvidarLocal(anio, mes);
          }
        },
        limpiar: function() { self.datos = null; self.expandido = null; }
      });
    },
    // Con el mes del que SON los datos, no con el del selector: el selector se ha podido mover
    // mientras la petición viajaba.
    guardarEnLocal: function(anio, mes) {
      try {
        localStorage.setItem('oeb_anal_data', JSON.stringify(this.datos));
        localStorage.setItem('oeb_anal_data_anio', anio);
        localStorage.setItem('oeb_anal_data_mes', mes);
      } catch (e) { /* localStorage full, ignore */ }
    },
    olvidarLocal: function(anio, mes) {
      if (parseInt(localStorage.getItem('oeb_anal_data_anio')) !== anio
        || parseInt(localStorage.getItem('oeb_anal_data_mes')) !== mes) return;
      localStorage.removeItem('oeb_anal_data');
      localStorage.removeItem('oeb_anal_data_anio');
      localStorage.removeItem('oeb_anal_data_mes');
    },
    // #769 · Por el mismo carril que la carga, como en Productividad: todo lo que escribe `datos`
    // pasa por él, así que una recarga del mismo mes que estuviera en vuelo ya no puede llegar
    // después y pisar lo recalculado —ni guardarlo en el navegador— con la copia de antes. Al
    // recargar el mismo mes los datos siguen a la vista y «Recalcular» se puede pulsar en ese rato;
    // fuera del carril, la carga y el recálculo eran dos escrituras que no se conocían (revisión
    // CODEX del PR #1845). Y un cambio de mes mientras recalcula lo descarta el carril.
    recalcular: function() {
      const self = this;
      self.recalculando = true;
      const anio = self.anio;
      const mes = self.mes;
      const terminar = function() { self.recalculando = false; };
      const avisarFallo = function(motivo, deQue) {
        if (self.$f7) self.$f7.dialog.alert('Error recalculando' + (deQue || '') + ': ' + motivo);
      };
      const motivoDe = function(err) { return err && err.message ? err.message : err; };
      self.carrilMes.lanzar(Oeb.recalcularAnalisisDiferencias(anio, mes), {
        exito: function(res) {
          terminar();
          if (unwrapDto(res)) {
            self.datos = unwrapDto(res);
            self.guardarEnLocal(anio, mes);
          } else {
            avisarFallo('respuesta del servidor sin datos');
          }
        },
        fallo: function(err) {
          terminar();
          avisarFallo(motivoDe(err));
        },
        // Lo que lo adelanta es un «Recargar» del mismo mes pulsado mientras recalculaba, y esa
        // lectura pudo salir del servidor antes de que el recálculo terminara de escribir: con el
        // recálculo hecho, se vuelve a leer lo que ha dejado.
        //
        // Y el desenlace se dice igual que si mandara, como el «Actualizar» de Control de cifras
        // (#164): es una acción que se pidió, y callarse su fallo porque otra carga la adelantó
        // dejaba a la vista lo de antes como si se hubiera recalculado. Lleva el mes dentro porque
        // se puede leer con otro delante (revisión CODEX del PR #1845, ronda 5).
        descartada: function(ok, res) {
          terminar();
          if (self.cerrada) return;
          const deQue = ' ' + self.nombresMeses[mes - 1] + ' ' + anio;
          if (!ok) avisarFallo(motivoDe(res), deQue);
          else if (!unwrapDto(res)) avisarFallo('respuesta del servidor sin datos', deQue);
          if (ok && self.anio === anio && self.mes === mes) self.cargarDatos();
        }
      });
    },
    mesPrevio: function() { if (this.mes === 1) { this.mes = 12; this.anio--; } else { this.mes--; } this.cargarDatos(); },
    mesSiguiente: function() { if (this.mes === 12) { this.mes = 1; this.anio++; } else { this.mes++; } this.cargarDatos(); },
    toggleExpand: function(cod) { this.expandido = this.expandido === cod ? null : cod; localStorage.setItem('oeb_anal_expandido', this.expandido || ''); },
    causaPrincipal: function(p) {
      var map = {};
      if (!p.semanas) return '';
      p.semanas.forEach(function(s) { if (s.items) s.items.forEach(function(it) { map[it.causa] = (map[it.causa] || 0) + Math.abs(it.diferencia || 0); }); });
      var max = ''; var maxVal = 0;
      for (var c in map) { if (map[c] > maxVal) { maxVal = map[c]; max = c; } }
      return max;
    },
    contarItems: function(p) {
      var n = 0;
      if (p.semanas) p.semanas.forEach(function(s) { if (s.items) n += s.items.length; });
      return n;
    },
    semanasPersona: function(p) { return p.semanas || []; },
    itemsPersona: function(p) {
      var self = this; var items = [];
      if (p.semanas) p.semanas.forEach(function(s) {
        if (s.items) s.items.forEach(function(it) {
          if (!self.filtroCausa || it.causa === self.filtroCausa) {
            if (!self.mostrarOk && it.causa === 'OK') return;
            var copy = Object.assign({}, it); copy._sem = s.semana; items.push(copy);
          }
        });
      });
      return items.sort(function(a, b) { return Math.abs(b.diferencia || 0) - Math.abs(a.diferencia || 0); });
    },
    causaColor: function(c) {
      return { 'DESFASE_TEMPORAL':'#e6a817','TAREA_SIN_PEDIDO':'#7B2D8E','PENDIENTE_CONFIRMAR':'#0d6efd','SUMAR_IMPORTE_FALSE':'#888','PEDIDO_CANCELADO':'#8B0000','DIFERENCIA_IMPORTE':'#17a2b8','PLANIFICADA_SIN_EJECUTAR':'#dc3568','EJECUTADA_SIN_PLANIFICAR':'#2d5f3a','EJECUTADA_TPC_NO':'#FF6B35','TAREA_DOBLE_IMPORTE':'#E91E63','OK':'#2E7D32' }[c] || '#666';
    },
    causaLabel: function(c) {
      return { 'DESFASE_TEMPORAL':'Desfase temporal','TAREA_SIN_PEDIDO':'Tarea s/ped','PENDIENTE_CONFIRMAR':'Pdte.conf','SUMAR_IMPORTE_FALSE':'NoSuma','PEDIDO_CANCELADO':'Cancelado','DIFERENCIA_IMPORTE':'Dif.importe','PLANIFICADA_SIN_EJECUTAR':'Plan.s/ejec','EJECUTADA_SIN_PLANIFICAR':'Ejec.s/plan','EJECUTADA_TPC_NO':'Ejec.s/TPC','TAREA_DOBLE_IMPORTE':'Tarea doble','OK':'OK' }[c] || c;
    },
    fmtEur: function(v) { if (v == null) return '0 \u20AC'; return Math.round(v).toLocaleString('es-ES') + ' \u20AC'; },
    fmtEurSigno: function(v) { if (v == null) return '0 \u20AC'; return (v >= 0 ? '+' : '') + Math.round(v).toLocaleString('es-ES') + ' \u20AC'; },
    fmtEurCorto: function(v) { if (v == null) return '0'; return Math.round(v).toLocaleString('es-ES'); }
  }
};
</script>
